import { useReducedMotion } from 'framer-motion';
import type { RefObject } from 'react';
import { useEffect } from 'react';

import { useIsInView } from '@/app/hooks/useIsInView';

export const useKeepInView = (
  divRef: RefObject<HTMLDivElement | null>,
  buttonRef: RefObject<HTMLDivElement | null>,
  shouldBeInView: boolean,
) => {
  const shouldReduceMotion = useReducedMotion();
  const isButtonInView = useIsInView(
    buttonRef as RefObject<HTMLDivElement>,
    0.1,
  );

  useEffect(() => {
    if (!divRef.current || !shouldBeInView) return;

    divRef.current.scrollIntoView({
      behavior: shouldReduceMotion ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'center',
    });

    const timeoutId = setTimeout(() => {
      if (!buttonRef.current || isButtonInView.current) return;
      // This delayed check ensures that after the card has expanded, it will always be in view.
      // Currently this should only fire for the last card in very specific situations.
      buttonRef.current.scrollIntoView({
        behavior: shouldReduceMotion ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }, 200);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [shouldBeInView, divRef, buttonRef, isButtonInView, shouldReduceMotion]);
};
